import React from 'react';
import { Route } from 'react-router-dom';
import UserInvitation from './userInvitations';
export default (
  <Route path="/homepage/convites-do-usuario" component={UserInvitation} />
);
